module.exports = __webpack_public_path__ + "img/occupied.da7a707d.svg";